import React from 'react';
import tick from '../../assets/error_icon.svg';
import './RegistrationErrorPage.scss';
import NavHeader from '../../components/NavHeader/NavHeader';

const RegistrationErrorPage: React.FC<SignUpErrorProps> = () => (
  <div className="registration-error-page">
    <NavHeader drawerOpen={false} handleDrawerToggle={() => {}} />
    <div className="registration-error-container">
      <img className="registration-error-icon" src={tick} alt="Sign up success icon" />
      <div className="dev-portal-title">Oh no!</div>
      <div className="registration-error-description">
        We ran into some technical trouble when creating your test HAT PDA. Your information has not
        been taken. Please try again later!
      </div>
    </div>
  </div>
);

interface SignUpErrorProps {
  path?: string;
}

export default RegistrationErrorPage;
